<div class="ot-dropdown" [ngClass]="{'ot-dropdown--is-active': showList}">
  <div class="ot-form-control" style="flex: 1;padding-right: 16px;margin-bottom:8px">
    <input [id]="identifier" #extVenFileInputText maxLength="25" i18n-placeholder placeholder="Enter a file name" type="text" class="ot-input" [(ngModel)]="queryText" (ngModelChange)="onQueryTextChanged($event)" autocomplete="off">
  </div>
  @if (showList) {
    <ul class="ot-dropdown__menu" style="max-width:unset;width: 100%;" [ngStyle]="{'height': scrollHeight}">
      <ng-scrollbar [visibility]="'always'">
        @for (file of extFiles; track file) {
          <li class="ot-dropdown__item" (click)="onSelect(file)">
            <div [innerHtml]="file.name | highlightText : queryText"></div>
          </li>
        }
      </ng-scrollbar>
      @if (extFiles.length == 0) {
        <li class="ot-dropdown__item" id="ot-header__item__notification_no_items_msg">
          <span i18n>There are no items to display.</span>
        </li>
      }
    </ul>
  }
</div>
<div class="ot-chips ot-pl-0 ot-pt-0">
  @if (selectedExtVenderFileName && selectedExtVenderFileName != '') {
    <div class="ot-chip" style="margin-left:0px">
      {{selectedExtVenderFileName}}
      <button class="ot-chip__close" (click)="removeSelectedFile()" title="Remove" i18n-title>
      </button>
    </div>
  }
</div>